module.exports = __webpack_public_path__ + "static/media/load_blue.3e68276f.gif";